import React from 'react';
import PropTypes from 'prop-types';
import { getImagem } from '../../utils/imagens';

const isVideoPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  return /\.(mp4|webm|ogg)$/i.test(path);
};

const BannerFixo = ({ banner, banners, posicao, standalone, className }) => {
  const dados =
    banner ||
    (Array.isArray(banners) && posicao
      ? banners.find((b) => b.posicao === posicao)
      : null);

  if (!dados) return null;

  const caminhoMidia = dados.video || dados.imagem;
  const src = getImagem(caminhoMidia);
  if (!src) return null;

  const posicaoNum = posicao || dados.posicao;
  const classePosicao = posicaoNum ? `banner-fixo-posicao-${posicaoNum}` : '';
  const isVideo =
    Boolean(dados.video) || dados.tipo === 'video' || isVideoPath(caminhoMidia);

  const mediaElement = isVideo ? (
    <video
      src={src}
      autoPlay
      loop
      muted
      playsInline
      width={dados.width || 768}
      height={dados.height || 90}
      title={dados.alt || `Banner ${posicaoNum || ''}`}
    />
  ) : (
    <img
      src={src}
      alt={dados.alt || `Banner ${posicaoNum || ''}`}
      width={dados.width || 768}
      height={dados.height || 90}
    />
  );

  const bannerContent = (
    <div className={`banner-fixo ${classePosicao} ${className}`.trim()}>
      {dados.href ? (
        <a
          href={dados.href}
          target="_blank"
          rel="noopener noreferrer"
          className="align-banner"
        >
          {mediaElement}
        </a>
      ) : (
        <div className="align-banner">{mediaElement}</div>
      )}
    </div>
  );

  if (standalone) {
    return (
      <section className="in-banner-standalone-section">
        {bannerContent}
      </section>
    );
  }

  return bannerContent;
};

const bannerItemShape = PropTypes.shape({
  posicao: PropTypes.number,
  imagem: PropTypes.string,
  video: PropTypes.string,
  tipo: PropTypes.string,
  alt: PropTypes.string,
  href: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

BannerFixo.propTypes = {
  banner: bannerItemShape,
  banners: PropTypes.arrayOf(bannerItemShape),
  posicao: PropTypes.number,
  standalone: PropTypes.bool,
  className: PropTypes.string
};

BannerFixo.defaultProps = {
  banner: null,
  banners: null,
  posicao: null,
  standalone: false,
  className: ''
};

export default BannerFixo;
